<template>
<section>
    <div class="wrap">
        <ul class="review_step_ul">
            <li :class="{ now : stepChk.isSc , chk : stepChk.isShop || stepChk.isTrim }">
                <span></span>
                <p>컨설턴트</p>
            </li>
            <li :class="{ now : stepChk.isShop || stepChk.isTrim , chk : stepChk.isTrim }">
                <span></span>
                <p>전시장</p>
            </li>
            <li :class="{ now : stepChk.isTrim }">
                <span></span>
                <p>차량</p>
            </li>
        </ul>

        <div class="new_content_box1">
            <div class="review_content_box">

                <figure :class="{ 'reviewTrimImg' : (dtype == TABLE_TYPE.TRIM.id) }">
                    <img :src="(item.att) ? item.att.url :reviewImg" />
                </figure>

                <figcaption>

                    <dl v-if="dtype == TABLE_TYPE.SC.id">
                        <dt>{{ item.name }} 컨설턴트</dt>

                        <dd>
                            {{ (item.shop) ? item.shop.name : ''}}
                            ({{(item.dealer) ? item.dealer.name : ''}})
                        </dd>
                    </dl>

                    <dl v-if="dtype == TABLE_TYPE.SHOP.id">

                        <dt>{{ item.name }}<span>{{ (item.dealer) ? item.dealer.name : '' }}</span></dt>
                        <dd>{{ item.addr }}</dd>

                    </dl>

                    <dl v-if="dtype == TABLE_TYPE.TRIM.id">
                        <dt>{{ item.name }}</dt>
                        <dd>
                            {{ (item.model) ? item.model.name : ''}}
                            ({{ (item.brand) ? item.brand.name: ''}})
                        </dd>
                    </dl>
                    <!--
                    <div class="social_div" style="margin-top:10px">
                        <span><i class="fas fa-heart"></i>{{ (item.reviewScore) ? item.reviewScore.good : 0 }}</span>
                        <span><i class="fas fa-comment"></i>{{ (item.reviewScore) ? item.reviewScore.reviewCount : 0 }}</span>
                    </div>
                    -->
                </figcaption>
                
            </div>
        </div>
        
        <div class="new_content_box2">
            <h3 class="title" style="margin-bottom:0; justify-content: center">
                <span>{{titleMessage}}</span>
            </h3>
            <div class="star_box">
                <p>{{review.rating}}</p>
                <star-rating
                    v-model="review.rating"
                    :increment="0.5"
                    :max-rating="5"
                    :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                    inactive-color="#E9EAEC"
                    active-color="#FFE78A"
                    :star-size="30">
                </star-rating>
            </div>
            
        </div>
        
        <!--
        <div class="new_content_box1">
            <h3 class="title">
                <span>평점</span>
            </h3>

            <div class="review_evaluation_box">
                <div class="review_evaluation">
                    <template v-for="(important, key) in REVIEW_SCORE">
                        <input type="radio" :id="`score-${important.id}`" name="type" :key="key" v-model="review.score" :value="`${important.id}`">
                        <label :for="`score-${important.id}`" :key="key+'-1'">{{important.title}}</label>
                    </template>
                </div>
            </div>
        </div>
        -->

        <div class="new_content_box1">
            <h3 class="title">
                <span>어떤 점이 좋았나요?</span>
            </h3>

            <div class="review_evaluation_box">
                <div class="review_evaluation">
                    <template v-for="(important, key) in REVIEW_DETAIL_SCORE">
                        <input type="checkbox" :id="`detail-Score-${important.id}`" v-model="review.detailScore" :value="important.id" :key="key">
                        <label :for="`detail-Score-${important.id}`" :key="key+'-1'">{{important.title}}</label>
                    </template>
                </div>

                <p>자세한 후기를 남겨주세요. <span>(선택사항)</span></p>

                <textarea 
                    class="reservation_textarea" 
                    placeholder="내용을 입력해주세요."
                    v-model="review.content"
                ></textarea>
            </div>
        </div>    
         <div style="height:76px;"></div>
    </div>

    <button class="default_fixed_btn" @click="validation()">다음으로</button>
</section>
</template>

<script>
import { mapState } from 'vuex';
import StarRating  from "vue-star-rating";
export default {
    name:'BookingInputDetail',
    data() {
        return {
            item: {},
            
            review: {
                rating: 0.0,
                dtype: '',
                score: '',
                detailScore: [],
                content: '',
            }
        }
    },
    created() {
        this.$store.state.headerTitle = '후기 입력';
        this.$store.dispatch('GET_BOOKING', this.bookingId)
        .then((data) => {
            this.getItem(data);
        });
    },
    components: { 
        StarRating
    },
    computed: {
        ...mapState({
            auth: state => state.auth.item,
            bookingItem: state => state.booking.item,
            reviewList: state => state.review.reviewList,

            TABLE_TYPE: state => state.codeDictionary.items.TABLE_TYPE,
            REVIEW_SCORE: state => state.codeDictionary.items.REVIEW_SCORE,
            REVIEW_SC_DETAIL_SCORE: state => state.codeDictionary.items.REVIEW_SC_DETAIL_SCORE,
            REVIEW_SHOP_DETAIL_SCORE: state => state.codeDictionary.items.REVIEW_SHOP_DETAIL_SCORE,
            REVIEW_TRIM_DETAIL_SCORE: state => state.codeDictionary.items.REVIEW_TRIM_DETAIL_SCORE,
            
        }),

        bookingId() {
            return this.$route.params.bookingId;
        },

        routeName() {
            return this.$route.name;
        },

        dtype() {
            if(this.routeName == 'ReviewScInput') return this.TABLE_TYPE.SC.id;
            else if(this.routeName == 'ReviewShopInput') return this.TABLE_TYPE.SHOP.id;
            else if(this.routeName == 'ReviewTrimInput') return this.TABLE_TYPE.TRIM.id;
            else return 0;
        },

        itemType() {
            if(this.dtype == this.TABLE_TYPE.SC.id) return 'SC';
            else if(this.dtype == this.TABLE_TYPE.SHOP.id) return 'SHOP';
            else if(this.dtype == this.TABLE_TYPE.TRIM.id) return 'TRIM';
            return '';
        },

        stepChk(){
            let step = {
                isSc: true,
                isShop: false,
                isTrim: false,
            }

            if(this.dtype == this.TABLE_TYPE.SHOP.id) step.isShop = true;
            if(this.dtype == this.TABLE_TYPE.TRIM.id) step.isTrim = true;

            return step;
        },

        titleMessage() {
            if(this.dtype == this.TABLE_TYPE.SC.id) return '만나보신 컨설턴트는 어떠셨나요?';
            else if(this.dtype == this.TABLE_TYPE.SHOP.id) return '전시장 느낌은 어떠셨나요?';
            else if(this.dtype == this.TABLE_TYPE.TRIM.id) return '차량에 대한 느낌은 어떠셨나요?';
            return '';
        },

        reviewImg(){
            if(this.dtype == this.TABLE_TYPE.SC.id) return this.$store.state.resource.imgSampleConsultantSquare;
            else if(this.dtype == this.TABLE_TYPE.SHOP.id) return this.$store.state.resource.imgSampleShopSquare;
            else if(this.dtype == this.TABLE_TYPE.TRIM.id) return this.$store.state.resource.imgSampleTrimSquare;
            return ''
        },

        REVIEW_DETAIL_SCORE(){
            if(this.dtype == this.TABLE_TYPE.SC.id) return this.REVIEW_SC_DETAIL_SCORE;
            else if(this.dtype == this.TABLE_TYPE.SHOP.id) return this.REVIEW_SHOP_DETAIL_SCORE;
            else if(this.dtype == this.TABLE_TYPE.TRIM.id) return this.REVIEW_TRIM_DETAIL_SCORE;
            return [] 
        },

        routerPath() {
            if(this.dtype == this.TABLE_TYPE.SC.id) return `/reviewShopInput/${this.bookingId}`;
            else if(this.dtype == this.TABLE_TYPE.SHOP.id) return `/reviewTrimInput/${this.bookingId}`;
            else if(this.dtype == this.TABLE_TYPE.TRIM.id) return `/main`;
            else return '/main';
        },
        
        
    },
    methods: {
        async getItem(booking){

            let id = 0;
            if(this.dtype == this.TABLE_TYPE.SC.id) id = booking.sc.id;
            else if(this.dtype == this.TABLE_TYPE.SHOP.id) id = booking.shop.id;
            else if(this.dtype == this.TABLE_TYPE.TRIM.id) id = booking.trim.id;

            await this.$store.dispatch(`GET_${this.itemType}`, id)
            .then((data) => {
                this.item = data;
                this.$store.commit('SHOW_ONLOAD');
            })
            .catch((e)=>{
                this.$store.commit('SHOW_ONLOAD');
                this.apiCatch(e);
            })

            
        },

        validation(){

            try {
                if(!this.review.rating) throw '평가는 필수 사항입니다.';

                this.next();
            }
            catch (errorMsg) {
                this.$store.commit('OPEN_MODAL', {
                    title: '알림', 
                    content: errorMsg, 
                    btnOne: '확인', 
                });
                return false;
            }
   
        },
        next() {
            this.review.dtype = this.dtype;

            switch(this.dtype){
                case this.TABLE_TYPE.SC.id:
                    this.reviewList.sc = {...this.review};
                    break;
                case this.TABLE_TYPE.SHOP.id:
                    this.reviewList.shop = {...this.review};
                    break;
                case this.TABLE_TYPE.TRIM.id:
                    this.reviewList.trim = {...this.review};
                    break;
            }

            if(this.dtype == this.TABLE_TYPE.TRIM.id) 
                this.submit();
            else 
                this.$router.push(this.routerPath);
        },

        submit() {
            
            this.$store.dispatch('CREATE_REVIEW',{
                userId: this.auth.id,
                bookingId: this.bookingId,
                reviewList: this.reviewList,
            })
            .then(()=>{
                this.$store.commit('OPEN_MODAL', { 
                    content: '리뷰 등록이 완료되었습니다.',
                    btnOne:'확인',
                    btnOneSubmit: () => { 
                        this.$router.push(this.routerPath) 
                    }
                });
            })
            .catch((e)=>{
                this.apiCatch(e);
            });
        }
    },
}
</script>

<style lang="scss" scoped>

</style>